/**
 * 解析社区 configData / configPayload。
 * 兼容：JSON 字符串、双重 stringify、已反序列化的对象。
 */
export function parseCommunityConfigPayload(
  raw?: unknown
): Record<string, unknown> {
  if (raw == null) return {};
  if (typeof raw === "object" && !Array.isArray(raw)) {
    return raw as Record<string, unknown>;
  }
  if (typeof raw !== "string") return {};

  let current: unknown = raw.trim();
  if (current === "") return {};

  for (let depth = 0; depth < 3; depth++) {
    if (typeof current !== "string") break;
    try {
      current = JSON.parse(current);
    } catch {
      return {};
    }
  }

  if (current && typeof current === "object" && !Array.isArray(current)) {
    return current as Record<string, unknown>;
  }
  return {};
}

export function hasCommunityConfigPayload(
  payload: Record<string, unknown> | undefined | null
): boolean {
  if (!payload || typeof payload !== "object") return false;
  return Object.keys(payload).length > 0;
}
